<template>
  <div
    class="d-flex align-items-center justify-content-between"
    :class="{'disabled': !state}"
  >
    <div
      class="gj-tag mr-sm-1 flex-fill"
      :class="status.isHealthy ? 'success' : 'danger'"
    >
      <div class="d-flex">
        <div>
          <img
            :src="status.dataCenter.imageUrl"
            alt="flag"
            class="tag-img"
          >
        </div>
        <span class="text-medium ml-1">{{ status.isHealthy ? 'Healthy' : 'Unhealthy' }}</span>
      </div>
    </div>
    <a
      class="more"
      @click="$emit('show-more', $event)"
    >
      <GjIcon
        name="Moreoptions"
        size="20"
        style="width: 22px;"
      />
    </a>
  </div>
</template>
<script>
export default {
  name: 'HealthcheckStatusLogs',
  props: {
    state: {
      type: Boolean,
      required: true,
    },
    status: {
      type: Object,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.more {
  border: 1px solid #E0E5EB;
  border-radius: 50%;
}

.gj-tag {
  // position: relative;
  // box-sizing: border-box;
  // border-radius: 25px;
  // padding: 5px 17px;
  // color: var(--white);
  // &.healthy {
  //   background: rgba(54, 179, 126, 0.8);
  //   border: 1px solid var(--success);
  // }
  // &.unhealthy {
  //   background: rgba(227, 72, 80, 0.8);
  //   border: 1px solid var(--danger);
  // }

  .tag-img {
    width: 15px;
    box-shadow: 2px 2px 8px 1px rgb(0 0 0 / 50%);
  }
  @media (max-width: 575.8px) {
    padding: 5px;
    margin-right: 5px;
  }
}

.disabled {
  .gj-tag {
    border: 0 !important;
      background: rgba(255, 171, 0, 0.2);
    > div {
      opacity: 0;
    }
    &::after {
      position: absolute;
      content: 'Disabled';
      border-radius: 25px;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      top: 0;
      left: 0;
      color: var(--warning);
      font-weight: 500;
    }
  }
  .more {
    pointer-events: none;
    opacity: 0.1;
  }
}
</style>
